import decodeToken from 'utils/decode-token';
import { useParams } from 'react-router';

export const useTokenDecode = () => {
    const { token } = useParams();

    const payload = decodeToken(token);

    const transactionId = payload?.transactionId;

    if (!transactionId) {
        throw new Error('Invalid Transaction');
    }

    return { ...payload, token };
};
